var map = {
	"./mn_tea_head_1.png": 105,
	"./mn_tea_head_2.png": 106,
	"./mn_tea_head_3.png": 107,
	"./mn_tea_head_4.png": 108,
	"./mn_tea_head_5.png": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 241;